'use strict';

const loadUser = navigator_ => ($stateParams, $state, auth, tmhDynamicLocale) => {
	if ($stateParams.site == null || $stateParams.site === '') {
		$state.go('SwitchAccounts', {});
		return Promise.reject();
	}

	return auth.getUser($stateParams.site).then(function (user) {
		const clientLanguage =
			(navigator_.languages && navigator_.languages[0]) ||
			navigator_.language ||
			navigator_.userLanguage;
		const locale =
			user.settings.locale == null || user.settings.locale === 'browser'
				? clientLanguage.toLowerCase()
				: user.settings.locale;
		tmhDynamicLocale.set(locale);
		return user;
	});
};

const loadUserFactory = navigator_ => {
	return {
		loadUser: loadUser(navigator_)
	};
};

module.exports = {
	loadUserFactory
};
